module.exports = __webpack_public_path__ + "img/game1.9de0ec59.png";